import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ProductOptionAlertPageRoutingModule } from './product-option-alert-routing.module';

import { ProductOptionAlertPage } from './product-option-alert.page';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    MatFormFieldModule,
    MatSelectModule,
    ProductOptionAlertPageRoutingModule,
    TranslateModule,
    MatDialogModule
  ],
  exports: [ ProductOptionAlertPage ],
  declarations: [ProductOptionAlertPage]
})
export class ProductOptionAlertPageModule {}
